/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { ItauWebhookUpdateRequest } from '../model/itauWebhookUpdateRequest';
import { PaymentExpirationConfigUpdateRequest } from '../model/paymentExpirationConfigUpdateRequest';
import { ResponseB4AItauCobrancaRecorrenteResponse } from '../model/responseB4AItauCobrancaRecorrenteResponse';
import { ResponseB4AItauCobrancaResponse } from '../model/responseB4AItauCobrancaResponse';
import { ResponseB4AItauRecorrenciaResponse } from '../model/responseB4AItauRecorrenciaResponse';
import { ResponseB4AItauWebhookResponse } from '../model/responseB4AItauWebhookResponse';
import { ResponseB4AListItauCobrancaRecorrenteResponse } from '../model/responseB4AListItauCobrancaRecorrenteResponse';
import { ResponseB4AListItauCobrancaResponse } from '../model/responseB4AListItauCobrancaResponse';
import { ResponseB4AListItauRecorrenciaResponse } from '../model/responseB4AListItauRecorrenciaResponse';
import { ResponseB4AListPagarMeCustomerResponse } from '../model/responseB4AListPagarMeCustomerResponse';
import { ResponseB4AListPaymentExpirationConfig } from '../model/responseB4AListPaymentExpirationConfig';
import { ResponseB4AListPaymentExpirationConfigLogDetail } from '../model/responseB4AListPaymentExpirationConfigLogDetail';
import { ResponseB4AListSubscriptionTypePaymentPriority } from '../model/responseB4AListSubscriptionTypePaymentPriority';
import { ResponseB4APaymentExpirationConfig } from '../model/responseB4APaymentExpirationConfig';
import { ResponseB4ARetentionPaymentConfig } from '../model/responseB4ARetentionPaymentConfig';
import { ResponseB4AString } from '../model/responseB4AString';
import { RetentionPaymentConfigUpdateRequest } from '../model/retentionPaymentConfigUpdateRequest';
import { SubscriptionTypePaymentPriority } from '../model/subscriptionTypePaymentPriority';

import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable()
export class FinancialAdminControllerService {
  public configuration = new Configuration();

  public defaultHeaders = new HttpHeaders();
  protected basePath = 'http://localhost:8080';
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public approveAllRefunds(
    body: Array<number>,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AString>;
  public approveAllRefunds(
    body: Array<number>,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AString>>;
  public approveAllRefunds(
    body: Array<number>,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AString>>;
  public approveAllRefunds(
    body: Array<number>,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling approveAllRefunds.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AString>(
      'post',
      `${this.basePath}/financial/admin/refunds/approve-all`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param subscriberBillingId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public approveRefund(
    subscriberBillingId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AString>;
  public approveRefund(
    subscriberBillingId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AString>>;
  public approveRefund(
    subscriberBillingId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AString>>;
  public approveRefund(
    subscriberBillingId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (subscriberBillingId === null || subscriberBillingId === undefined) {
      throw new Error(
        'Required parameter subscriberBillingId was null or undefined when calling approveRefund.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AString>(
      'post',
      `${this.basePath}/financial/admin/refunds/approve/${encodeURIComponent(String(subscriberBillingId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param txid
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cancelInstantCharge(
    txid: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AItauCobrancaResponse>;
  public cancelInstantCharge(
    txid: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AItauCobrancaResponse>>;
  public cancelInstantCharge(
    txid: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AItauCobrancaResponse>>;
  public cancelInstantCharge(
    txid: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (txid === null || txid === undefined) {
      throw new Error(
        'Required parameter txid was null or undefined when calling cancelInstantCharge.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AItauCobrancaResponse>(
      'delete',
      `${this.basePath}/financial/admin/itau/cob/${encodeURIComponent(String(txid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param idRec
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cancelRecurrence(
    idRec: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AItauRecorrenciaResponse>;
  public cancelRecurrence(
    idRec: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AItauRecorrenciaResponse>>;
  public cancelRecurrence(
    idRec: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AItauRecorrenciaResponse>>;
  public cancelRecurrence(
    idRec: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (idRec === null || idRec === undefined) {
      throw new Error(
        'Required parameter idRec was null or undefined when calling cancelRecurrence.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AItauRecorrenciaResponse>(
      'delete',
      `${this.basePath}/financial/admin/itau/rec/${encodeURIComponent(String(idRec))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param txid
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cancelRecurrentCharge(
    txid: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AItauCobrancaRecorrenteResponse>;
  public cancelRecurrentCharge(
    txid: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AItauCobrancaRecorrenteResponse>>;
  public cancelRecurrentCharge(
    txid: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AItauCobrancaRecorrenteResponse>>;
  public cancelRecurrentCharge(
    txid: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (txid === null || txid === undefined) {
      throw new Error(
        'Required parameter txid was null or undefined when calling cancelRecurrentCharge.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AItauCobrancaRecorrenteResponse>(
      'delete',
      `${this.basePath}/financial/admin/itau/cobr/${encodeURIComponent(String(txid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param webhookType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteItauWebhook(
    webhookType: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AString>;
  public deleteItauWebhook(
    webhookType: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AString>>;
  public deleteItauWebhook(
    webhookType: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AString>>;
  public deleteItauWebhook(
    webhookType: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (webhookType === null || webhookType === undefined) {
      throw new Error(
        'Required parameter webhookType was null or undefined when calling deleteItauWebhook.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AString>(
      'delete',
      `${this.basePath}/financial/admin/itau/webhook/${encodeURIComponent(String(webhookType))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSubscriptionTypePaymentPriority(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListSubscriptionTypePaymentPriority>;
  public deleteSubscriptionTypePaymentPriority(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListSubscriptionTypePaymentPriority>>;
  public deleteSubscriptionTypePaymentPriority(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListSubscriptionTypePaymentPriority>>;
  public deleteSubscriptionTypePaymentPriority(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListSubscriptionTypePaymentPriority>(
      'delete',
      `${this.basePath}/financial/admin/subscription-type-payment-priority`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param inicio
   * @param fim
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findCobrancas(
    inicio: string,
    fim: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListItauCobrancaResponse>;
  public findCobrancas(
    inicio: string,
    fim: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListItauCobrancaResponse>>;
  public findCobrancas(
    inicio: string,
    fim: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListItauCobrancaResponse>>;
  public findCobrancas(
    inicio: string,
    fim: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (inicio === null || inicio === undefined) {
      throw new Error(
        'Required parameter inicio was null or undefined when calling findCobrancas.'
      );
    }

    if (fim === null || fim === undefined) {
      throw new Error(
        'Required parameter fim was null or undefined when calling findCobrancas.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (inicio !== undefined && inicio !== null) {
      queryParameters = queryParameters.set('inicio', <any>inicio);
    }
    if (fim !== undefined && fim !== null) {
      queryParameters = queryParameters.set('fim', <any>fim);
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListItauCobrancaResponse>(
      'get',
      `${this.basePath}/financial/admin/itau/cobs`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param inicio
   * @param fim
   * @param idRec
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findCobrancasRecorrentes(
    inicio: string,
    fim: string,
    idRec?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListItauCobrancaRecorrenteResponse>;
  public findCobrancasRecorrentes(
    inicio: string,
    fim: string,
    idRec?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListItauCobrancaRecorrenteResponse>>;
  public findCobrancasRecorrentes(
    inicio: string,
    fim: string,
    idRec?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListItauCobrancaRecorrenteResponse>>;
  public findCobrancasRecorrentes(
    inicio: string,
    fim: string,
    idRec?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (inicio === null || inicio === undefined) {
      throw new Error(
        'Required parameter inicio was null or undefined when calling findCobrancasRecorrentes.'
      );
    }

    if (fim === null || fim === undefined) {
      throw new Error(
        'Required parameter fim was null or undefined when calling findCobrancasRecorrentes.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (inicio !== undefined && inicio !== null) {
      queryParameters = queryParameters.set('inicio', <any>inicio);
    }
    if (fim !== undefined && fim !== null) {
      queryParameters = queryParameters.set('fim', <any>fim);
    }
    if (idRec !== undefined && idRec !== null) {
      queryParameters = queryParameters.set('idRec', <any>idRec);
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListItauCobrancaRecorrenteResponse>(
      'get',
      `${this.basePath}/financial/admin/itau/cobsr`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param inicio
   * @param fim
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findRecurrences(
    inicio: string,
    fim: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListItauRecorrenciaResponse>;
  public findRecurrences(
    inicio: string,
    fim: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListItauRecorrenciaResponse>>;
  public findRecurrences(
    inicio: string,
    fim: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListItauRecorrenciaResponse>>;
  public findRecurrences(
    inicio: string,
    fim: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (inicio === null || inicio === undefined) {
      throw new Error(
        'Required parameter inicio was null or undefined when calling findRecurrences.'
      );
    }

    if (fim === null || fim === undefined) {
      throw new Error(
        'Required parameter fim was null or undefined when calling findRecurrences.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (inicio !== undefined && inicio !== null) {
      queryParameters = queryParameters.set('inicio', <any>inicio);
    }
    if (fim !== undefined && fim !== null) {
      queryParameters = queryParameters.set('fim', <any>fim);
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListItauRecorrenciaResponse>(
      'get',
      `${this.basePath}/financial/admin/itau/recs`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param webhookType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getItauWebhook(
    webhookType: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AItauWebhookResponse>;
  public getItauWebhook(
    webhookType: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AItauWebhookResponse>>;
  public getItauWebhook(
    webhookType: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AItauWebhookResponse>>;
  public getItauWebhook(
    webhookType: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (webhookType === null || webhookType === undefined) {
      throw new Error(
        'Required parameter webhookType was null or undefined when calling getItauWebhook.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AItauWebhookResponse>(
      'get',
      `${this.basePath}/financial/admin/itau/webhook/${encodeURIComponent(String(webhookType))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPaymentExpirationConfigLogs(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListPaymentExpirationConfigLogDetail>;
  public getPaymentExpirationConfigLogs(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListPaymentExpirationConfigLogDetail>>;
  public getPaymentExpirationConfigLogs(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListPaymentExpirationConfigLogDetail>>;
  public getPaymentExpirationConfigLogs(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListPaymentExpirationConfigLogDetail>(
      'get',
      `${this.basePath}/financial/admin/payment-expiration-config/logs`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPaymentExpirationConfigs(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListPaymentExpirationConfig>;
  public getPaymentExpirationConfigs(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListPaymentExpirationConfig>>;
  public getPaymentExpirationConfigs(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListPaymentExpirationConfig>>;
  public getPaymentExpirationConfigs(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListPaymentExpirationConfig>(
      'get',
      `${this.basePath}/financial/admin/payment-expiration-config`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param idRec
   * @param txid
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRecurrenceDetails(
    idRec: string,
    txid: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AItauRecorrenciaResponse>;
  public getRecurrenceDetails(
    idRec: string,
    txid: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AItauRecorrenciaResponse>>;
  public getRecurrenceDetails(
    idRec: string,
    txid: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AItauRecorrenciaResponse>>;
  public getRecurrenceDetails(
    idRec: string,
    txid: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (idRec === null || idRec === undefined) {
      throw new Error(
        'Required parameter idRec was null or undefined when calling getRecurrenceDetails.'
      );
    }

    if (txid === null || txid === undefined) {
      throw new Error(
        'Required parameter txid was null or undefined when calling getRecurrenceDetails.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AItauRecorrenciaResponse>(
      'get',
      `${this.basePath}/financial/admin/itau/rec/details/${encodeURIComponent(String(idRec))}/${encodeURIComponent(String(txid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public refreshRefundTickets(
    body: Array<number>,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AString>;
  public refreshRefundTickets(
    body: Array<number>,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AString>>;
  public refreshRefundTickets(
    body: Array<number>,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AString>>;
  public refreshRefundTickets(
    body: Array<number>,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling refreshRefundTickets.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AString>(
      'put',
      `${this.basePath}/financial/admin/upgrade-refund`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCustomersAndTokens(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListPagarMeCustomerResponse>;
  public updateCustomersAndTokens(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListPagarMeCustomerResponse>>;
  public updateCustomersAndTokens(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListPagarMeCustomerResponse>>;
  public updateCustomersAndTokens(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListPagarMeCustomerResponse>(
      'get',
      `${this.basePath}/financial/admin/pagarme/v5/customers`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param webhookType
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateItauWebhook(
    body: ItauWebhookUpdateRequest,
    webhookType: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AString>;
  public updateItauWebhook(
    body: ItauWebhookUpdateRequest,
    webhookType: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AString>>;
  public updateItauWebhook(
    body: ItauWebhookUpdateRequest,
    webhookType: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AString>>;
  public updateItauWebhook(
    body: ItauWebhookUpdateRequest,
    webhookType: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateItauWebhook.'
      );
    }

    if (webhookType === null || webhookType === undefined) {
      throw new Error(
        'Required parameter webhookType was null or undefined when calling updateItauWebhook.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AString>(
      'put',
      `${this.basePath}/financial/admin/itau/webhook/${encodeURIComponent(String(webhookType))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param paymentExpirationConfigId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePaymentExpirationConfig(
    body: PaymentExpirationConfigUpdateRequest,
    paymentExpirationConfigId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4APaymentExpirationConfig>;
  public updatePaymentExpirationConfig(
    body: PaymentExpirationConfigUpdateRequest,
    paymentExpirationConfigId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4APaymentExpirationConfig>>;
  public updatePaymentExpirationConfig(
    body: PaymentExpirationConfigUpdateRequest,
    paymentExpirationConfigId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4APaymentExpirationConfig>>;
  public updatePaymentExpirationConfig(
    body: PaymentExpirationConfigUpdateRequest,
    paymentExpirationConfigId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updatePaymentExpirationConfig.'
      );
    }

    if (
      paymentExpirationConfigId === null ||
      paymentExpirationConfigId === undefined
    ) {
      throw new Error(
        'Required parameter paymentExpirationConfigId was null or undefined when calling updatePaymentExpirationConfig.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4APaymentExpirationConfig>(
      'put',
      `${this.basePath}/financial/admin/payment-expiration-config/${encodeURIComponent(String(paymentExpirationConfigId))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePixRecurrenceBotSchedule(
    body: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AString>;
  public updatePixRecurrenceBotSchedule(
    body: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AString>>;
  public updatePixRecurrenceBotSchedule(
    body: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AString>>;
  public updatePixRecurrenceBotSchedule(
    body: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updatePixRecurrenceBotSchedule.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AString>(
      'put',
      `${this.basePath}/financial/admin/pix-recurrence-bot/schedule`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param configId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateRetentionPaymentConfig(
    body: RetentionPaymentConfigUpdateRequest,
    configId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ARetentionPaymentConfig>;
  public updateRetentionPaymentConfig(
    body: RetentionPaymentConfigUpdateRequest,
    configId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ARetentionPaymentConfig>>;
  public updateRetentionPaymentConfig(
    body: RetentionPaymentConfigUpdateRequest,
    configId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ARetentionPaymentConfig>>;
  public updateRetentionPaymentConfig(
    body: RetentionPaymentConfigUpdateRequest,
    configId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateRetentionPaymentConfig.'
      );
    }

    if (configId === null || configId === undefined) {
      throw new Error(
        'Required parameter configId was null or undefined when calling updateRetentionPaymentConfig.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4ARetentionPaymentConfig>(
      'put',
      `${this.basePath}/financial/admin/anual-monthly/config/${encodeURIComponent(String(configId))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSubscriptionTypePaymentPriority(
    body: Array<SubscriptionTypePaymentPriority>,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListSubscriptionTypePaymentPriority>;
  public updateSubscriptionTypePaymentPriority(
    body: Array<SubscriptionTypePaymentPriority>,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListSubscriptionTypePaymentPriority>>;
  public updateSubscriptionTypePaymentPriority(
    body: Array<SubscriptionTypePaymentPriority>,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListSubscriptionTypePaymentPriority>>;
  public updateSubscriptionTypePaymentPriority(
    body: Array<SubscriptionTypePaymentPriority>,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateSubscriptionTypePaymentPriority.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AListSubscriptionTypePaymentPriority>(
      'put',
      `${this.basePath}/financial/admin/subscription-type-payment-priority`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
}
